import React from "react";

export default function HeroVideoPanel({ isDarkMode }) {
  return (
    <div className="relative w-full h-[240px] rounded-2xl overflow-hidden mb-6">
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/hero-video.mp4" type="video/mp4" />
      </video>

      {/* Gradient Overlay — adapts to light/dark mode */}
      <div
        className={`absolute inset-0 ${
          isDarkMode
            ? "bg-gradient-to-t from-[#030c1b] via-[rgba(3,12,27,0.7)] to-[rgba(3,12,27,0.4)]"
            : "bg-gradient-to-t from-white/90 via-white/70 to-white/40"
        }`}
      />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-end p-6">
        <h1
          className={`text-2xl md:text-3xl font-bold mb-2 tracking-tight ${
            isDarkMode ? "text-white" : "text-gray-900"
          }`}
        >
          Intelligence at the Speed of Markets
        </h1>
        <p
          className={`text-sm md:text-base max-w-xl ${
            isDarkMode ? "text-[#94a3b8]" : "text-gray-600"
          }`}
        >
          AI-driven market sizing, segmentation, and growth forecasting.
        </p>
      </div>


    </div>
  );
}
